import Backbone from 'backbone';
import Constants from 'root/constants';

export default Backbone.Model.extend({
    defaults: {
        account_id            : 0,
        start_day             : 0,
        start_month           : 0,
        start_year            : 0,
        end_day               : 0,
        end_month             : 0,
        end_year              : 0,
        amount                : 0,
        credt                 : 0,
        status                : Constants.UNPAID,
        type                  : '',
        has_gst               : false,
        paid_time             : 0,
        description           : '',
        statement_description : ''
    }
});